import React, { useState, useRef, useEffect } from 'react'
import moment from 'moment'
import { MarkedText, Input, RadioGroup, SingleSelectInput } from '../common/atoms'
import { handleAppError } from '../handlers'
import { successOrFailureToaster } from '../common/atoms/messages'
import { Table } from '../common/molecules'
import { EmployeeDataHoc } from '../../utils/hocs'
import { employeeDataApi } from '../../services'
import { vip_tag } from '../../assets/images'
import { familyUpdateSchema as tableschema } from '../../schemas/table'
import { ADD_EMPLOYEE_PLACEHOLDER, UPDATE_EMPLOYEE_LABELS, UPDATE_EMPLOYEE_NAMES } from '../../constants/employeeData'
import { DatePicker } from '../tailwind/molecules'
import { ALL_COUNTRIES_ISD_CODES, SALES_ROLE } from '../../constants/overview'
import { dropdownDownArrow } from '../../assets/images'
import Dropdown from '../common/atoms/Dropdown'

const createNewData = (data) => {
  return data.map((item) => {
    return { ...item }
  })
}

const ManageEmployeeForm = ({ history, location }) => {
  const data = useRef({ ...JSON.parse(location.state.data) })

  const [state, setState] = useState({ ...data.current })
  const [entities, setEntities] = useState([])
  const [grades, setGrades] = useState([])
  const [familydata, setFamilyData] = useState(createNewData([]))
  const staticData = useRef({})
  const [openDropdown, updateOpenDropdown] = useState(false)

  const [isdCode, setIsdCode] = useState(state.isd_code || '+91')
  const allCountryIsdCode = ALL_COUNTRIES_ISD_CODES.map(code => ({...code, disabled: ( code.id !== isdCode ) }))

  const updateSelectedItem = (item) => {
    setIsdCode(item.id)
    updateOpenDropdown(false)
  }

  const preprocessData = (data) => {
    return data.map((item) => {
      let arr = (item.date_of_birth || '').split('-')
      if (arr.length === 3) [arr[0], arr[2]] = [arr[2], arr[0]]
      item.date_of_birth = arr.join('-')

      return { ...item }
    })
  }

  const fetchFamilyDetails = () => {
    employeeDataApi.fetch_family_members(
      { id: state.id },
      (res) => {
        const data = preprocessData(res.data.family_members || [])
        setFamilyData(data)
        staticData.current = createNewData(data)
      },
      (err) => handleAppError(err)
    )
  }

  const fetchEntityDetails = () => {
    employeeDataApi.fetch_entity_details(
      { id: state.sponsor },
      (res) => {
        const data = res.data.entities || []
        const entityValue = data.find((option) => option.name === state.entity_name)?.id
        setState((prevState) => { return { ...prevState, entity_id: entityValue } })
        setEntities(data)
      },
      (err) => handleAppError(err)
    )
  }

  const fetchGradesDetails = () => {
    employeeDataApi.company_grades(
      { companyId: state.sponsor },
      (res) => {
        let data = res.data.grades || []   
        const grade = data.find((option) => option === state.grade)
        data.push('UNGRADED').uniq
        setState((prevState) => { return { ...prevState, grade: grade } })
        setGrades(data)
      },
      (err) => handleAppError(err)
    )
  }

  const onSave = () => {
    const { relation, ...data } = state
    data.isd_code = isdCode
    const options = { id: state.id, data }

    employeeDataApi.update_employees(
      options,
      (res) => {
        successOrFailureToaster({message : 'Employee Details has been updated'})
        data.current = res.data || data.current
        history.push('/manage-employee')
      },
      (err) => handleAppError(err)
    )
  }

  const formHandler = (event) => {
    let name = '' , value =''
    if(['date_of_birth', 'entity_name', 'grade'].includes(event.name)) {
      name = event.name
      value = event.value
    }
    else {
      name = event.target.name
      value = event.target.value
    }

    if (name === 'vip') value = value === 'Yes'
    if(name == 'entity_name'){
      const entityValue = entities.find((option) => option.name === value)?.id
      setState((prevState) => { return { ...prevState, entity_id: entityValue, [name]: value } })
    if (name == 'grade'){
      const grade = grades.find((option) => option === state.grade)
      setState((prevState) => { return { ...prevState, grade: grade } })
    }
    }else{
      setState((prevState) => { return { ...prevState, [name]: value } })
    }
  }

  const toggleEdit = (index, type) => {
    let newData = createNewData(familydata)
    if (type === 'open') {
      newData[index].edit = true
    } else {
      newData[index] = { ...staticData.current[index], edit: false }
    }
    setFamilyData(newData)
  }

  const changeHandler = (index, name, value, action_type) => {
    if (name.includes('gender')) name = 'gender'

    if(name.includes('date_of_birth'))  {
      value = value.trim().replace(/\D$/, '')
      const len = value.length
      if(len === 2 || len === 5) {
        value = action_type !== 'deleteContentBackward' ? value + '-' : value.slice(0, value.length-1)
      }
    }
    
    const newData = createNewData(familydata)
    newData[index][name] = value
    setFamilyData(newData)
  }

  const saveHandler = (index) => {
    if (SALES_ROLE == 'sales') return 
    const { date_of_birth } = familydata[index]

    try {
      if (date_of_birth) {
        let arr = date_of_birth.split('-'),
          resflag = true
        const flag = arr[0].length === 2 && arr[1].length === 2 && arr[2].length === 4
        if (!(arr.length === 3 && flag && moment(date_of_birth, 'DD MM YYYY').isSameOrBefore(moment(new Date())))) resflag = false
        if (resflag) resflag = moment(date_of_birth, 'DD MM YYYY').isValid()

        if (!resflag) throw new Error('Date of birth is not valid')
      }

      employeeDataApi.update_family_member(
        { id: familydata[index].id, data: familydata[index] },
        (res) => {
          successOrFailureToaster({message : 'Family member has been updated.'})
          fetchFamilyDetails()
        },
        (err) => {
          handleAppError(err)
          toggleEdit(index, 'close')
        }
      )
    } catch (err) {
      successOrFailureToaster({ message : err.message, type: 'fail' })
      toggleEdit(index, 'close')
    }
  }

  useEffect(() => {
    fetchFamilyDetails()
    fetchEntityDetails()
    fetchGradesDetails()
  }, [])

  let date_of_birth = moment(state?.date_of_birth).format('DD-MM-YYYY')
  const entityNames = entities.map((item) => item.name)
  return (
    <React.Fragment>
    <EmployeeDataHoc
      classes='pb-24'
      title='Employee Details'
      breadcrumb={[
        { text: 'Manage Employees', link: '/manage-employee' },
        { text: `${state.name}`, link: '#' },
      ]}
      close={() => history.goBack()}
    >
      <div className='flex items-center mt-6'>
        <h1 className='text-gray-900 text-2xl font-bold mb-0 inline-block'>{state.name}</h1>
        <MarkedText classes='ml-3 text-gray-700' flag={state.customer_status === 'Active'}>
          {state.customer_status}
        </MarkedText>
        {state.vip && <img src={vip_tag} alt='vipicon' className='inline-block ml-2 text-gray-700' />}
      </div>

      <h1 className='text-sm font-semibold tracking-widest leading-3 text-gray-500 mt-6 mb-3'>EMPLOYEE DETAILS</h1>
      <div className='bg-white rounded-md border'>
        <div className='grid grid-cols-3 gap-x-4 gap-y-6 p-6'>
          {UPDATE_EMPLOYEE_NAMES.map((item, ind) => {
            const label = UPDATE_EMPLOYEE_LABELS[ind]
            const placeholder = ADD_EMPLOYEE_PLACEHOLDER[ind]
            return (
            <div>
              {item === 'date_of_birth' ?
              <DatePicker
                labelClasses='font-semibold tracking-widest leading-3 mb-3'
                label={label}
                value = {date_of_birth}
                disabled={true}
                placeholder={placeholder}
                inputClasses='text-gray-300  cursor-not-allowed border bg-gray-100 font-semibold text-base leading-4 w-full'
                classes ='mt-4'
                color='#7c8cab'
                size='12px'
                handler={(value) => {
                  let name='date_of_birth'
                  formHandler({name, value})
                }} 
                height='46px'
              />: item === 'mobile_number' ?
              <div className='flex justify-start'>
              <Dropdown
                selectedItem={isdCode} toggleList={()=>updateOpenDropdown(!openDropdown)} listOpen={openDropdown} 
                onChange={updateSelectedItem} list={allCountryIsdCode}  title={isdCode} padding={"12px 8px 12px 10px"} 
                dropDownIcon={dropdownDownArrow} fontSize={'14px'} closeOnClickOverlay={true}
                marginTopOptions={'6'} mr={'2'} borderRequired={true}  
              />
               <Input key={ind} placeholder={placeholder} disable={item === 'email' && true} inputClasses={` placeholder-gray-275 text-base h-12 ${ item === 'email' ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700'}`} labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3' value={state[item]} name={item} label={label} type={item === 'mobile_number' ? 'number' : 'text'} handler={formHandler}  />
             </div>
              :
              <Input key={ind} placeholder={placeholder} disable={item === 'email' && true} inputClasses={` placeholder-gray-275 text-base h-12 ${ item === 'email' ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700'}`} labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3' value={state[item]} name={item} label={label} type={item === 'mobile_number' ? 'number' : 'text'} handler={formHandler}  />
              }
            </div> 
            )
          })}
          { entityNames.length > 0 ? 
            <SingleSelectInput 
              onChangeHandler={formHandler}  
              value={state.entity_name || ''}
              data={entityNames}
              search={true}
              name='entity_name'
              placeholder='Select' 
              label='ENTITY NAME' 
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize p-6 pb-5'
              bgColor='bg-gray-100 capitalize'
              disable={SALES_ROLE === "sales"}
              placeholderClasses='h-4'
            />
            : null
          }
          <SingleSelectInput 
            onChangeHandler={formHandler}  
            value={state.grade || 'UNGRADED'}
            data={grades}
            name='grade'
            placeholder='Select' 
            label='GRADE' 
            labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
            listClasses='z-20'
            listItemClasses='capitalize p-6 pb-5'
            bgColor='bg-gray-100 capitalize'
            disable={grades.length == 0}
            placeholderClasses='h-4'
          />
        </div>
        <div className='p-6 pt-0 grid grid-cols-3 gap-x-4'>
          <RadioGroup title='GENDER' radioList={['Male', 'Female', 'Non-binary']} labelClases='text-gray-700 text-base leading-4 ml-3 font-semibold font-proxima-nova' name='gender' radioClasses='grid-cols-3' titleClasses='text-xs font-semibold tracking-widest mb-3 leading-3 text-gray-500' radioInputClasses='h-5 w-5' value={state.gender} handler={formHandler} />
          <RadioGroup title='VIP CUSTOMER' radioList={['Yes', 'No']} name='vip' labelClases='text-gray-700 text-base leading-4 ml-3 font-semibold font-proxima-nova' titleClasses='text-xs  font-semibold tracking-widest leading-3 text-gray-500 mb-3' radioInputClasses='h-5 w-5' value={state.vip ? 'Yes' : 'No'} handler={formHandler} />
        </div>

        <div className='p-4 text-right border' style={{backgroundColor : '#f5f8ff'}}>
          <button className='border border-gray-275 text-base leading-4 text-blue-600 font-semibold py-3.5 px-6 rounded-md focus:outline-none' onClick={() => history.goBack()}>
            Cancel
          </button>
          <button disabled={SALES_ROLE === "sales"} className={`bg-blue-600 leading-4 text-base text-white font-semibold py-3.5 px-6 rounded-md ml-3 focus:outline-none hover:bg-blue-600 ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={onSave}>
            Save
          </button>
        </div>
      </div>

      <h1 className='text-gray-500 text-sm tracking-widest font-semibold mt-8 mb-4'>FAMILY MEMBERS</h1>
      <Table
        headers={['First Name', 'Last Name', 'Relation', 'DOB', 'Gender', '']}
        tableschema={tableschema}
        data={familydata}
        tableClasses='alternate_gray200_color'
        classes='rounded-md'
        toggleEdit={toggleEdit}
        changeHandler={changeHandler}
        saveHandler={saveHandler}
      />
    </EmployeeDataHoc>
    </React.Fragment>
  )
}

export default ManageEmployeeForm
